<template>
  <div class="box">
    <div class="wish" @click="clickWish('yes')">
      <div class="text" :class="[yes_class]">
        1. 會
      </div>
      <img v-if="yes" class="img" src="/assets/image/yes.png" />
      <img v-if="yes_active" class="img" src="/assets/image/yes-active.png" />
    </div>
    <div class="wish" @click="clickWish('no')">
      <div class="text" :class="[no_class]">
        2. 不會
      </div>
      <img v-if="no" class="img" src="/assets/image/no.png" />
      <img v-if="no_active" class="img" src="/assets/image/no-active.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyTestAgain",
  data() {
    return {
      yes: true,
      yes_active: false,
      no: true,
      no_active: false,
      yes_class: 'unselect',
      no_class: 'unselect',
    }
  },
  methods: {
    clickWish: function (option) {
      if (option === 'yes') {
        this.yes = this.no_active = false;
        this.yes_active = this.no = true;
        this.yes_class = 'selected';
        this.no_class = 'unselect';
        this.$emit('getTestAgain', 1);
      } else {
        this.yes_active = this.no = false;
        this.yes = this.no_active = true;
        this.no_class = 'selected';
        this.yes_class = 'unselect';
        this.$emit('getTestAgain', 0);
      }

    }
  }
}
</script>

<style scoped>
.box{
  display: flex;
  justify-content: center;
  gap: clamp(1rem, 4vw, 3rem);
  margin-top: 4vh;
}
.wish{
  position: relative;
  flex: 0 1 clamp(12rem, 24vw, 18rem);
  min-height: clamp(15rem, 28vw, 20rem);
  margin: 0 0 3vh;
  cursor: default;
}
.text{
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  min-height: clamp(9rem, 18vw, 13rem);
  border-radius: 8px;
  padding: clamp(1rem, 3vw, 2rem);
  font-size: var(--ecs-font-lg);
  line-height: 1.2;
}
.img{
  width: clamp(7rem, 14vw, 10rem);
  position: absolute;
  top: clamp(7rem, 14vw, 10rem);
  left: 50%;
  transform: translateX(-50%);
}
.unselect{
  color: #666666;
  border: #666666 3px solid;
}
.selected{
  color: #94c43b;
  border: #94c43b 3px solid;
}
@media (orientation: landscape) and (max-height: 480px) {
  .box{
    margin-top: 2vh;
  }

  .wish{
    min-height: clamp(10rem, 22vw, 14rem);
  }

  .text{
    min-height: clamp(6rem, 14vw, 9rem);
  }

  .img{
    top: clamp(4.5rem, 10vw, 7rem);
    width: clamp(4.5rem, 10vw, 7rem);
  }
}
</style>
